// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

// Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
import {AuthLoading, Unauthorized} from '@dishtech-react/core';

// Contexts
import {RouteContext} from '../contexts/route-context';
import logo from '../assets/dish_red.svg';

const AuthLayout = ({children}) => {
  const authorized = useSelector(({auth: {user: {isAuthorized} = {}} = {}}) => isAuthorized);
  const isCredentialExpired = useSelector(
    ({auth: {user: {credentialsNonExpired} = {}} = {}}) => !credentialsNonExpired
  );
  return (
    <div className="main">
      <RouteContext.Provider value={useRouter()}>
        {isCredentialExpired ? (
          <AuthLoading img={logo} />
        ) : authorized ? (
          <div className="main--content">{children}</div>
        ) : (
          <Unauthorized />
        )}
      </RouteContext.Provider>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node,
};

export default AuthLayout;
